import React, { useEffect, useState } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import Lottie from 'lottie-react';
export function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  return <section className="w-full bg-gradient-to-b from-gray-900 via-gray-900 to-gray-800 pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden relative" data-id="element-179">
      {/* Animated background gradient */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-180">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl animate-pulse" data-id="element-181"></div>
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-182"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10" data-id="element-183">
        <div className="text-center max-w-4xl mx-auto" data-id="element-184">
          <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-185">
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 mb-8" data-id="element-186">
              <Sparkles className="h-4 w-4 text-purple-400" data-id="element-187" />
              <span className="text-sm text-gray-300" data-id="element-188">
                12 powerful tools. One plugin. Zero complexity.
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight" data-id="element-189">
              The Only WooCommerce Plugin That{' '}
              <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent" data-id="element-190">
                Pays for Itself in Days
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-400 mb-10 leading-relaxed" data-id="element-191">
              Stop buying 12 different plugins. Get product badges, bulk
              discounts, flash sales, wishlists, side cart, AJAX search,
              reviews, wholesale pricing, gift cards, and more—all working
              together seamlessly to multiply your revenue.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-192">
              <a href="#pricing" className="group inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-medium rounded-lg transition-all text-lg shadow-lg shadow-purple-500/25" data-id="element-193">
                Start Free—Upgrade When You're Ready
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-194" />
              </a>
              <a href="#showcase" className="inline-flex items-center justify-center px-8 py-4 text-gray-300 hover:text-white font-medium text-lg transition-colors border border-white/10 rounded-lg hover:border-white/20" data-id="element-195">
                See all 12 tools in action →
              </a>
            </div>
          </div>
        </div>

        <div className={`mt-16 transition-all duration-1000 delay-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-196">
          <div className="relative max-w-5xl mx-auto" data-id="element-197">
            <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-2xl border border-white/10 shadow-2xl overflow-hidden" data-id="element-198">
              <div className="bg-gray-800/50 px-4 py-3 flex items-center gap-2 border-b border-white/10" data-id="element-199">
                <div className="flex gap-1.5" data-id="element-200">
                  <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-201"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-202"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-203"></div>
                </div>
                <div className="flex-1 text-center text-sm text-gray-500" data-id="element-204">
                  your-store.com
                </div>
              </div>
              <div className="p-8" data-id="element-205">
                <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="WooCommerce Store Dashboard" className="w-full rounded-lg" data-id="element-206" />
              </div>
            </div>

            {/* Glow effects */}
            <div className="absolute -bottom-10 -left-10 w-72 h-72 bg-purple-600/30 rounded-full blur-3xl" data-id="element-207"></div>
            <div className="absolute -top-10 -right-10 w-72 h-72 bg-blue-600/30 rounded-full blur-3xl" data-id="element-208"></div>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-sm text-gray-400" data-id="element-209">
          <span className="flex items-center gap-2" data-id="element-210">
            <svg className="h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-211">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-212" />
            </svg>
            5 Essential Tools FREE Forever
          </span>
          <span className="flex items-center gap-2" data-id="element-213">
            <svg className="h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-214">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-215" />
            </svg>
            30-Day Money-Back Guarantee
          </span>
          <span className="flex items-center gap-2" data-id="element-216">
            <svg className="h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-217">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-218" />
            </svg>
            Works With Any Theme
          </span>
        </div>
      </div>
    </section>;
}